export default __webpack_public_path__ + "static/loreal-next-image-20e1a234712690ce5025694455257d53.jpg";